<template>
  <v-row>
    <v-col cols="4" sm="4" md="4">
      <v-autocomplete
        v-model="ServicioId"
        :items="ArrayServices"
        item-title="DescripcionServicio"
        item-value="ServicioID"
        label="Servicio a guardar:"
        clearable
      ></v-autocomplete>
    </v-col>
    <v-col cols="4" sm="4" md="4">
      <v-autocomplete
        v-model="NotificationId"
        :items="ArrayNotificaciones"
        item-title="Descripcion"
        item-value="NotificacionId"
        label="Tipo de notificación:"
        clearable
      ></v-autocomplete>
    </v-col>
    <!--Fecha de Notificaciones -->
    <v-col cols="4" sm="4" md="4">
      <v-text-field
        v-model="FechaProgramada"
        label="Fecha y Hora Programada:"
        type="datetime-local"
        clearable
      ></v-text-field>
    </v-col>
    <v-col cols="10">
      <v-file-input
        show-size
        counter
        v-model="fileUpload"
        accept=".csv"
        label="Seleccione el archivo masivo:"
        clearable
      ></v-file-input>
    </v-col>
    <!-- Guardar -->
    <v-col cols="2">
      <v-btn
        block
        @click="convertToBase64()"
        text
        dark
        size="x-large"
        color="green"
      >
        <template v-slot:prepend>
          <v-icon>mdi-content-save</v-icon>
        </template>
        Guardar</v-btn
      >
    </v-col>
  </v-row>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Migracion-Activos",
  data() {
    return {
      progreso: false,
      fileUpload: [],
      ServicioId: 0,
      NotificationId: 0,
      ArrayServices: [],
      ArrayNotificaciones: [],
      FechaProgramada: "",
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Envia Archivo Base 64
    async convertToBase64() {
      if (this.fileUpload.length > 0) {
        // Archivo Masivo
        const file = this.fileUpload[0]; // Obtener el archivo seleccionado
        console.log(file);
        if (!file) return;

        const buffer = await file.arrayBuffer();
        const bytes = Array.from(new Uint8Array(buffer));

        var userperfil = this.$store.getters.userperfil;
        var page = this.$store.getters.userperfil.paginainfo;
        var servicioID = 0;
        if (page.param1) {
          servicioID = parseInt(page.param1);
        }

        var data = {
          ArchiveMassive: bytes,
          Servicio: this.ServicioId,
          Notificacion: this.NotificationId,
          UsuarioLogin: userperfil.userInfo.Usuario_ID,
          FechaProgramada: this.FechaProgramada,
        };

        this.getPostArvhivoAEP(data); // Enviar la cadena Base64
      } else {
        this.$swal({
          icon: "warning",
          title: "Archivos Incompletos.",
          html: "Por favor, suba los archivos antes de guardar",
        });
      }
    },

    // Envia Archivo masivo
    async getPostArvhivoAEP(data) {
      this.progreso = true;
      this.axios
        .post(
          "/Personas/Id_ComunicacionTrazabilidad/CRMassiveNotificacion",
          data
        )
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Relación Guardada",
            html: "La información se ha guardado correctamente.",
          });
          this.fileUpload = [];
          this.ServicioId = 0;
          this.NotificationId = 0;
          this.FechaProgramada = null;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
  },
  mounted() {
    this.ArrayServices = this.$store.getters.MServicio;
    this.ArrayNotificaciones = this.$store.getters.MNotificacion;
  },
};
</script>